<div *ngIf="!(isUser | async)">
  <div class="guest-panel">
    <app-home-screen></app-home-screen>
  </div>
</div>

<div *ngIf="isUser | async">
  <div class="container fixed-top navbar-class">
    <div class="-d flex">
    <app-nav-user (showLogin)="handleLoggedOut()"></app-nav-user>
    </div>
  </div>
  <app-home-header class="section"></app-home-header>
  <app-home-orders class="section" fragment="orders" id="orders"></app-home-orders>
  <!--
  <app-youtube class="section" fragment="channel" id="channel"></app-youtube>
  <app-home-contact class="section" fragment="contact" id="contact"></app-home-contact>
  <app-map></app-map>
  <div style="height: 100px;"></div>
  -->
</div>
